import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { GradientMenu } from './GradientMenu';
import { SolidColorMenu } from './SolidColorMenu';

export const ColorMenuTab = memo(() => {
  const { t } = useTranslation('editor_edit_background_menu', { useSuspense: false });

  return (
    <Box overflow='hidden'>
      <Tabs variant='sub-menu' isLazy>
        <TabList m={4}>
          <Tab data-testid='bg-color-solid-tab' textTransform={'capitalize'}>
            {t('colorMenu.solid')}
          </Tab>
          <Tab data-testid='bg-color-gradient-tab' textTransform={'capitalize'}>
            {t('colorMenu.gradient')}
          </Tab>
        </TabList>
        <TabPanels flex='1' overflowY='auto' overflowX='hidden' pt={0}>
          <TabPanel p={4}>
            <SolidColorMenu />
          </TabPanel>
          <TabPanel _focus={{ boxShadow: 'none' }}>
            <GradientMenu />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
});

ColorMenuTab.displayName = 'ColorMenuTab';
